class NavToggler {
    //1. describe and create/initiate our object
    constructor() {
        this.toggleButton = document.querySelector('.fa-bars');
        this.closeButton = document.querySelector('.closebtn');
        this.overlay = document.querySelector('#myNav');
        this.categories = document.querySelectorAll('.toggle-menu a');
        this.categoriesUl = document.querySelectorAll('.toggle-menu ul');
        this.topNavbarCategories = document.querySelectorAll('.navbar-category > a');
        this.events();
        
    }

    //2.  events
    events () {


        const mediaQuery = window.matchMedia('(min-width: 768px)');
        mediaQuery.addEventListener("change", () => {
            this.closeOverlay();
        });
    

        

        // Adds + sign to categories in the top menu Navbar
        this.topNavbarCategories.forEach(topCategory => {
            topCategory.innerHTML += "<span style='margin-left:0.5em'>+</span>";
        })


 
        this.toggleButton.addEventListener('click', this.openOverlay.bind(this));  
        this.categories.forEach(category => {

            const submenu = category.nextElementSibling;

            if (submenu) {
            category.innerHTML += "<span style='margin-left:0.5em'>+</span>";
            }
            category.addEventListener('click', function (e) {
                submenu.classList.toggle('show-sub-menu');
                category.scrollIntoView();
                e.preventDefault();
                category.querySelector('.greater-than').classList.toggle('greater-than-rotate');
           });   
        }); 


        this.closeButton.addEventListener('click', this.closeOverlay.bind(this));
    }


    //3. methods


    openOverlay() {
        this.overlay.style.width = "100%";
    }

    closeOpenCategories() {
        this.categoriesUl.forEach(category => {
            category.classList.remove("show-sub-menu"); // collapses all sub-menus 
    }); 
    }

    closeOverlay() {
        this.overlay.style.width = "0%";
        this.closeOpenCategories();
        
    }

}




export default NavToggler;